import { ITask, ITaskGroup } from '../../types/tasks.types'
import produce from 'immer'

const generateSandboxTask = (task: Partial<ITask> = {}): ITask => {
  return { group: '', type: 0, id: '', answerOptions: [], audio: [], images: [], ...task }
}

const immutableUpdateTask = (tasks: ITask[], task: ITask) => {
  return produce(tasks, (draft) => {
    const index = draft.findIndex((t) => t.id === task.id)
    if (index === -1) return

    draft.splice(index, 1, task)
  })
}

const immutableMoveGroups = (
  groupId: ITaskGroup['id'],
  movedId: ITaskGroup['id'],
  groups: ITaskGroup[]
): ITaskGroup[] => {
  return produce(groups, (draft) => {
    const groupIndex = draft.findIndex((g) => g.id === groupId)
    const movedIndex = draft.findIndex((g) => g.id === movedId)
    if (groupIndex === -1 || movedIndex === -1) return draft

    draft.splice(movedIndex, 1)
    draft.splice(groupIndex, 0, groups[movedIndex])
    const orderingIndexes = groups.map((g) => g.orderingIndex)
    for (let i = 0; i < orderingIndexes.length; ++i) {
      draft[i] = { ...draft[i], orderingIndex: groups[i].orderingIndex }
    }

    return draft
  })
}

const immutableMoveTasks = (taskId: ITask['id'], movedId: ITask['id'], tasks: ITask[]): ITask[] => {
  return produce(tasks, (draft) => {
    const taskIndex = draft.findIndex((t) => t.id === taskId)
    const movedIndex = draft.findIndex((t) => t.id === movedId)

    if (taskIndex === -1 || movedIndex === -1) return draft

    draft.splice(movedIndex, 1)
    draft.splice(taskIndex, 0, tasks[movedIndex])
    const orderingIndexes = tasks.map((g) => g.orderingIndex)
    for (let i = 0; i < orderingIndexes.length; ++i) {
      draft[i] = { ...draft[i], orderingIndex: tasks[i].orderingIndex }
    }

    return draft
  })
}

const sandboxUtils = { generateSandboxTask, immutableUpdateTask, immutableMoveGroups, immutableMoveTasks }
export default sandboxUtils
